import { action as apiAction } from 'api/Api'
import {
  setTimestamp
} from '../redux/dates'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number
  dateId: number
  timestamp: number
}

export default (payload: Payload) => async dispatch => {
  const { cardId, dateId, timestamp } = payload

  const optimisticAction = optimisticDispatch(dispatch, setTimestamp({
    cardId,
    dateId,
    timestamp
  }))

  try {
    await apiAction('SetCustomDate', {
      id: dateId,
      timestamp
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}
